import styled from 'styled-components'

export default styled.div`
  height: auto;
  margin-bottom: 10px;
  overflow: hidden;
  position: relative;
  width: 100%;
  @media screen and (max-width: 800px) and (-ms-high-contrast: active), screen and (max-width: 800px) and (-ms-high-contrast: none) {
    width: 80% !important;
    display: block !important;
  }
`
